import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36')
];

export const server_loads = [];

export const dictionary = {
		"/(accueil)": [2],
		"/accessibilite": [3],
		"/action-logement": [4],
		"/blog": [5],
		"/blog/5-idees-recues-sur-le-bail-reel-solidaire-brs": [6],
		"/blog/achat-logement-social-bail-reel-solidaire-brs": [7],
		"/blog/acheter-son-logement-sans-se-ruiner-3-solutions-a-connaitre-absolument": [8],
		"/blog/comment-savoir-si-je-suis-eligible-au-bail-reel-solidaire-brs": [9],
		"/blog/la-succession-en-bail-reel-solidaire-brs": [10],
		"/blog/le-bail-reel-solidaire-brs-cest-quoi-exactement": [11],
		"/blog/les-inconvenients-ou-contreparties-du-bail-reel-solidaire-brs": [12],
		"/blog/plafonds-de-revenus-brs-2026-tableau-complet-par-zone-et-composition-de-menage": [13],
		"/blog/puis-je-acheter-un-logement-en-brs-si-je-suis-deja-proprietaire": [14],
		"/blog/un-exemple-pour-vous-projeter-dans-votre-achat-en-brs": [15],
		"/conditions-generales-d-utilisation": [16],
		"/espace-presse": [17],
		"/groupe-csf": [18],
		"/groupe-la-poste": [19],
		"/logements-brs-disponibles": [20],
		"/matrice-impact": [21],
		"/mentions-legales": [22],
		"/notre-mission": [~23],
		"/nous-contacter": [24],
		"/organismes-de-foncier-solidaire": [~25],
		"/organismes-fonciers-solidaires": [~26],
		"/politique-de-confidentialite": [27],
		"/questionnaire": [28],
		"/revendre-mon-bien-en-brs": [29],
		"/simulateur-acquisition": [30],
		"/simulateur-eligibilite": [31],
		"/simulateur-eligibilite/steps": [32],
		"/statistiques-eligibilite": [~34],
		"/statistiques": [~33],
		"/tout-savoir-sur-le-bail-reel-solidaire-brs": [35],
		"/tout-savoir-sur-le-bail-reel-solidaire-brs/[slug]": [~36]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';